// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ef-d8tziRRLOpCkUn0x0t"};